<template>
  <div
    class="product__same-design"
    :class="{ 'mt-md': productSameDesign?.length }"
  >
    <template v-if="!loading && productSameDesign?.length">
      <span>More with This Design: &nbsp;</span>
      <sib-link
        v-for="(item, index) in productSameDesign.slice(0, SAME_DESIGN_LIMIT)"
        :key="index"
        :to="buildProductUrl(item.handle)"
        title=""
        :referer="PRODUCT_PAGE_SAME_DESIGN"
      >
        <span class="same-design__item" @click="trackingProductSameDesignClicked">
          {{ item.product_type.toUpperCase() }}
        </span>

        <span class="px-xs">|</span>
      </sib-link>

      <sib-link
        v-if="productSameDesign.length"
        :to="
          seeMoreCollectionHandle
            ? `/collections/${seeMoreCollectionHandle}`
            : `/search?query=${seeMoreTextSearch}&${
                productHasTagTmr ? 'tmr_search=true' : ''
              }`
        "
        title=""
        :referer="PRODUCT_PAGE_SAME_DESIGN"
      >
        <span class="same-design__item" @click="trackingProductSameDesignClicked">SEE MORE </span>
      </sib-link>
    </template>
    <template v-if="loading">
      <div class="product__same-design-skeleton">
        <sib-skeleton-loading
          height="21px"
          width="11em"
          class="mr-xs"
        ></sib-skeleton-loading>
        <sib-skeleton-loading
          height="21px"
          width="5em"
          class="mr-xs"
        ></sib-skeleton-loading>
        <sib-skeleton-loading
          height="21px"
          width="7em"
          class="mr-xs"
        ></sib-skeleton-loading>
        <sib-skeleton-loading
          height="21px"
          width="5em"
          class="mr-xs hidden-md-down"
        ></sib-skeleton-loading>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onServerPrefetch, onMounted, computed, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import useProductStore from '@/store/product'
import {
  PRODUCT_PAGE_SAME_DESIGN,
  QUERY_STRING_NO_CACHE,
  PRODUCT_TAG_TMR1,
  SEARCHANISE,
  EVENT_TRACKING_SAME_DESIGN_CLICKED,
} from '@/utils'
import { useFetchData } from '@/composables/fetchData'
import { buildProductUrl, isProductHasTags } from '@/utils/product'
import Analytics from '@/services/analytics'

const route = useRoute()
const productStore = useProductStore()

const productTitle = computed(() => productStore.product?.title || '')
const productHandle = computed(() => route.params.productHandle || '')
const productSameDesign = computed(() => productStore.productSameDesign || [])

const productHasTagTmr = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_TMR1])
)

const isSearchanise = computed(
  () => import.meta.env.VITE_SEARCH_TYPE == SEARCHANISE
)

const seeMoreTextSearch = computed(() =>
  isSearchanise.value
    ? productTitle.value?.split(' ')?.slice(0, 2)?.join(' ')
    : productTitle.value
)

const seeMoreCollectionHandle = computed(() => {
  return productStore.similarNicheCollectionHandle || ''
})

const SAME_DESIGN_LIMIT = 5

const { fetchData, loading } = useFetchData({
  fetchDataFunction: fetchProductSameDesign,
})

onServerPrefetch(async () => {
  await fetchData()
})

onMounted(() => {
  watch(
    () => productStore.product?.id,
    async (value) => {
      if (value && !productStore.productSameDesign) await fetchData()
    },
    {
      immediate: true,
    }
  )
})

onUnmounted(() => {
  productStore.productSameDesign = null
})

async function fetchProductSameDesign() {
  if (productHandle.value.toString()) {
    return await productStore.getProductSameDesign({
      handle: productHandle.value.toString(),
      store: import.meta.env.VITE_SEARCH_STORE,
      isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
    })
  }
  return null
}

function trackingProductSameDesignClicked() {
  Analytics.track(
    EVENT_TRACKING_SAME_DESIGN_CLICKED
  )
}
</script>

<style lang="scss">
.product__same-design {
  .same-design__item {
    color: var(--color-tertiary);
    text-decoration: underline;
  }
  .mr-xs {
    margin-right: var(--space-xsmall);
  }
}
</style>
